import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import Layout from './Layout';
import { AuthProvider } from "react-oidc-context";
import { COGNITO_AUTH_CONFIG } from "../config"

export default class Root extends Component {
  render() {
    const { store, history, persistor } = this.props;
    return (
      <Provider store={store}>
        <AuthProvider {...COGNITO_AUTH_CONFIG}>
          <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
              <Layout />
            </ConnectedRouter>
          </PersistGate>
        </AuthProvider>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  persistor: PropTypes.object.isRequired
};
